import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Peace from "./sections/Peace";
import Benefits from "./sections/Benefits";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Peace />
      <Benefits />
      <Footer />
    </div>;
}